import React from 'react';

import { ICampaignProps } from '@domain/interfaces/dashboard/AdsManager/Table/Campaign/ICampaign';

const Status: React.FC<ICampaignProps> = () => {
  return <></>;
};

export default Status;
